import { IS_PPP, user } from 'utils';

// PPP: pre-mount URL guard and redirects. Runs before React mounts.
//
// / (root)
//   Logged in → redirect to /{savedSellerID}/{savedStoreID}/account/orders
//   Not logged in → error screen
//
// /{sellerID} (no storeID)
//   Logged in + same sellerID → redirect to /{savedSellerID}/{savedStoreID}/account/orders
//   Otherwise → error screen
//
// /{sellerID}/{storeID}/...
//   IDs match session → allow through
//   IDs differ (any combo) → force logout, stay on new URL (login page for new combo)
export default function handlePPPRedirects() {
  if (!IS_PPP) return;

  const {
    sellerID: urlSellerID,
    storeID: urlStoreID
  } = user.getPPPIdsFromURL();
  const { sellerID: savedSellerID, storeID: savedStoreID } = user.getPPPIds();
  const hasValidSession = savedSellerID && savedStoreID && user.isLoggedIn();

  // root URL
  if (!urlSellerID && !urlStoreID) {
    if (hasValidSession) {
      window.location.replace(
        `/${savedSellerID}/${savedStoreID}/account/orders`
      );
    }
    return;
  }

  // /{sellerID} only — no storeID
  if (urlSellerID && !urlStoreID) {
    if (hasValidSession && urlSellerID === savedSellerID) {
      window.location.replace(
        `/${savedSellerID}/${savedStoreID}/account/orders`
      );
    }
    // different sellerID or not logged in → error screen
    return;
  }

  // /{sellerID}/{storeID}/... — check for mismatch
  const mismatch = urlSellerID !== savedSellerID || urlStoreID !== savedStoreID;

  if (mismatch && hasValidSession) {
    // Different seller+store combo — force logout, stay on new URL
    // App will mount with isLoggedIn=false and show login for this combo
    user.logout();
    sessionStorage.clear();
  }
}
